"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudySubjectBlindActionAudit = exports.StudyRandomizationAudit = exports.StudyRandomCodeAudit = exports.CrfAuditTrailSdv = exports.CrfAuditTrailLocking = exports.CrfAuditTrailFreezing = exports.CrfAuditTrailEsign = exports.CrfAuditTrailQuery = exports.CrfAuditTrailData = exports.CrfAuditTrailBasic = exports.StudyCodingAudit = exports.StudyQueryCaptureAudit = exports.StudyDataCaptureAudit = exports.StudySubjectAudit = exports.CrfAuditTrailType = void 0;
var CrfAuditTrailType;
(function (CrfAuditTrailType) {
    CrfAuditTrailType["All"] = "All";
    CrfAuditTrailType["Data"] = "Data";
    CrfAuditTrailType["Query"] = "Query";
    CrfAuditTrailType["SDV"] = "SDV";
    CrfAuditTrailType["Freezing"] = "Freezing";
    CrfAuditTrailType["Esign"] = "E-Sign";
    CrfAuditTrailType["Locking"] = "Locking";
})(CrfAuditTrailType = exports.CrfAuditTrailType || (exports.CrfAuditTrailType = {}));
class StudySubjectAudit {
}
exports.StudySubjectAudit = StudySubjectAudit;
class StudyDataCaptureAudit {
}
exports.StudyDataCaptureAudit = StudyDataCaptureAudit;
class StudyQueryCaptureAudit {
}
exports.StudyQueryCaptureAudit = StudyQueryCaptureAudit;
class StudyCodingAudit {
}
exports.StudyCodingAudit = StudyCodingAudit;
class CrfAuditTrailBasic {
}
exports.CrfAuditTrailBasic = CrfAuditTrailBasic;
class CrfAuditTrailData extends CrfAuditTrailBasic {
}
exports.CrfAuditTrailData = CrfAuditTrailData;
class CrfAuditTrailQuery extends CrfAuditTrailBasic {
}
exports.CrfAuditTrailQuery = CrfAuditTrailQuery;
class CrfAuditTrailEsign extends CrfAuditTrailBasic {
}
exports.CrfAuditTrailEsign = CrfAuditTrailEsign;
class CrfAuditTrailFreezing extends CrfAuditTrailBasic {
}
exports.CrfAuditTrailFreezing = CrfAuditTrailFreezing;
class CrfAuditTrailLocking extends CrfAuditTrailBasic {
}
exports.CrfAuditTrailLocking = CrfAuditTrailLocking;
class CrfAuditTrailSdv extends CrfAuditTrailBasic {
}
exports.CrfAuditTrailSdv = CrfAuditTrailSdv;
class StudyRandomCodeAudit {
}
exports.StudyRandomCodeAudit = StudyRandomCodeAudit;
class StudyRandomizationAudit {
}
exports.StudyRandomizationAudit = StudyRandomizationAudit;
class StudySubjectBlindActionAudit {
}
exports.StudySubjectBlindActionAudit = StudySubjectBlindActionAudit;
//# sourceMappingURL=resourceAudit.js.map